import React, { useEffect, useRef, useState } from 'react';
import { useUser } from '@/shared/providers/user-provider/use-user';

function JackpotLobbyWidget({ onClick }) {
  const widgetRef = useRef(null);
  const { user } = useUser();
  // const [currency, setCurrency] = useState<string>();

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'module';
    // script.src = '/components/jackpot-iife.js';
    script.src = '/jackpot-components/components/jackpot-iife.js';
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const el = widgetRef.current;

    if (el && onClick) {
      const handler = (e) => {
        onClick(e.detail);
      };

      el.addEventListener('click', handler);

      return () => {
        el.removeEventListener('click', handler);
      };
    }
  }, [onClick]);

  // useEffect(() => {
  //   setCurrency(user.currency ?? 'USD');
  // }, [user.currency]);

  const getCurrency = user.currency ?? 'USD';

  const getJackpotUrl = (): string => {
    const isDevelop = process.env.NEXT_PUBLIC_APP_ENV === 'development';
    const oid = isDevelop ? 9 : 6;
    return isDevelop
      ? `wss://test.loto-million.com/jackpot/${oid}?currency=${getCurrency}`
      : `wss://vamos-games.info/jackpot/${oid}?currency=${getCurrency}`;
  };

  return (
    <vamos-jackpot-lobby
      url={getJackpotUrl()}
      currency={getCurrency}
      ref={widgetRef}
      style={{ marginTop: '18px' }}
    />
  );
}

export default JackpotLobbyWidget;
